import 'vanilla-cookieconsent/dist/cookieconsent.css'
import * as CookieConsent from 'vanilla-cookieconsent'

// Preserve the cookie consent UI across Turbo navigations by moving #cc-main
// into the incoming body before Turbo swaps it out
document.addEventListener('turbo:before-render', (event) => {
  const ccMain = document.getElementById('cc-main')
  if (ccMain) event.detail.newBody.appendChild(ccMain)
})

// Re-attach click handlers to data-cc buttons after each Turbo body swap
document.addEventListener('turbo:load', () => {
  document.querySelectorAll('[data-cc="show-preferencesModal"]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault()
      CookieConsent.showPreferences()
    })
  })
})

CookieConsent.run({
  categories: {
    necessary: { enabled: true, readOnly: true },
    analytics: { enabled: false }
  },
  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: 'We use cookies',
          description: 'We use cookies to improve your experience. Choose which cookies you allow below.',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          showPreferencesBtn: 'Manage preferences'
        },
        preferencesModal: {
          title: 'Cookie preferences',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Save preferences',
          sections: [
            {
              title: 'Strictly necessary',
              description: 'Required for the site to function.',
              linkedCategory: 'necessary'
            },
            {
              title: 'Analytics',
              description: 'Help us understand how you use the site.',
              linkedCategory: 'analytics'
            },
            {
              title: 'More information',
              description: 'See our <a href="/legal/privacy">Privacy Policy</a> and <a href="/legal/cookies">Cookie Policy</a>.'
            }
          ]
        }
      }
    }
  }
})
